<template>
	<div class="address-box">
		<div class="title">
			<span>地址管理</span>
			<span @click="add">+新增地址</span>
		</div>
		<div class="address">
			<div class="header">
				<div class="name">收货人</div>
				<div class="area">所在地区</div>
				<div class="detail">收货人</div>
				<div class="zip">邮编</div>
				<div class="phone">手机</div>
				<div class="action">操作</div>
			</div>
			<div v-for="(item,index) in list" :key="index" class="item">
				<div class="name">{{ item.consignee }}</div>
				<div class="area">{{ item.province_name }} {{ item.city_name }} {{ item.zone_name }}</div>
				<div class="detail">{{ item.address }}</div>
				<div class="zip">{{ item.zip_code }}</div>
				<div class="phone">{{ item.mobile }}</div>
				<div class="action">
					<div @click="setDefault(item.address_id, item.is_default)" :class="item.is_default ? 'default':'set-default' ">
						{{ item.is_default ? '默认地址':'设为默认' }}</div>
					<div class="edit-box">
						<div @click="edit(item.address_id)">修改</div>|<div @click="del(index)">删除</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		myAddressList,
		defaultAddress,
		deleteAddress
	} from "@/api"
	export default {
		name: '',
		components: {

		},
		data() {
			return {
				list: []
			};
		},
		created() {
			this.loadData()
		},
		methods: {
			loadData() {
				myAddressList().then(res => {
					this.list = res.data
				})
			},
			setDefault(id, is_default) {
				if (is_default) {
					return
				}
				defaultAddress({
					id: id
				}).then(() => {
					this.loadData()
				})
			},
			add() {
				this.$router.push({
					path: "editaddress",
				});
			},
			edit(address_id){
				this.$router.push({
					path: "editaddress",
					query: { address_id: address_id}
				});
			},
			del(index) {
				deleteAddress({id:this.list[index].address_id}).then(()=>{
					this.list.splice(index,1)
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.address-box {
		width: 950px;
		background: #FFFFFF;
		padding: 20px;

		.title {
			display: flex;
			justify-content: space-between;
			align-items: center;
			color: #0F114A;
			font-size: 17px;
			font-weight: bold;
			cursor: pointer;
		}

		.address {
			background: #FFFFFF;
			border: 1px solid #EEEEEE;
			margin-top: 20px;
			font-size: 13px;

			.header {
				background: #F5F5F5;
				height: 40px;
				line-height: 40px;
			}

			.item {
				height: 80px;
				line-height: 80px;
				border-bottom: 1px solid #DDDDDD;

				.action {
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;

					.default {
						width: 62px;
						height: 24px;
						line-height: 24px;
						background: #0F114A;
						border-radius: 3px;
						font-size: 13px;
						color: #EDD4AC;
						text-align: center;
					}

					.set-default {
						width: 62px;
						height: 24px;
						line-height: 24px;
						background: #FFFFFF;
						border: 1px solid #0F114A;
						border-radius: 3px;
						font-size: 13px;
						color: #0F114A;
						text-align: center;
						cursor: pointer;
					}

					.edit-box {
						width: 62px;
						height: 18px;
						display: flex;
						justify-content: space-between;
						align-items: center;
						font-size: 13px;
						color: #333333;
						margin-top: 10px;
						cursor: pointer;
					}
				}
			}

			.item:last-child {
				border: none;
			}

			.item,
			.header {
				display: flex;

				div {

					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.name {
					width: 90px;
					padding-left: 20px;
				}

				.area {
					width: 150px;
					padding-left: 20px;
				}

				.detail {
					width: 320px;
					padding-left: 20px;
				}

				.zip {
					width: 100px;
					padding-left: 20px;
				}

				.phone {
					width: 140px;
					padding-left: 20px;
				}

				.action {
					width: 110px;
					padding-left: 20px;
				}
			}
		}

	}
</style>
